module.exports = __webpack_public_path__ + "img/sTaiga88_193x205.f8f5f79b.png";